
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/user",
      function () {
        return require("private-next-pages/settings/user.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/user"])
      });
    }
  